class ProductGiftNoteForm extends HTMLElement {
  constructor() {
    super();
    this.handleMessageInput = this.handleMessageInput.bind(this);
    this.handleSave = this.handleSave.bind(this);
    this.handleRemove = this.handleRemove.bind(this);
  }

  connectedCallback() {
    this.messageInput = this.querySelector(
      "[name='items[][properties][GiftMessage]']"
    );
    this.messageInput.addEventListener("input", this.handleMessageInput);
    this.saveButton = this.querySelector(".gift-note-form__button--save");
    this.saveButton.addEventListener("click", this.handleSave);
    this.removeButton = this.querySelector(".gift-note-form__button--remove");
    this.removeButton.addEventListener("click", this.handleRemove);
  }

  disconnectedCallback() {
    this.messageInput.removeEventListener("input", this.handleMessageInput);
    this.saveButton.removeEventListener("click", this.handleSave);
    this.removeButton.removeEventListener("click", this.handleRemove);
  }

  handleMessageInput() {
    if (this.messageInput.value) {
      this.removeButton.classList.remove("hidden");
    } else {
      this.removeButton.classList.add("hidden");
    }
  }

  handleSave() {
    const formId = this.dataset.productFormId;
    const inputs = this.querySelectorAll("[name^='items']");
    const modalDialog = this.closest("modal-dialog");
    const modalOpenerButton = document.querySelector(
      `[data-modal="#${modalDialog.id}"] button`
    );

    if (this.messageInput.value) {
      inputs.forEach((input) => {
        input.setAttribute("form", formId);
      });
      modalOpenerButton.classList.add("checked");
    } else {
      inputs.forEach((input) => {
        input.removeAttribute("form");
      });
      modalOpenerButton.classList.remove("checked");
    }

    modalDialog.hide();
  }

  handleRemove() {
    this.messageInput.value = "";
    this.removeButton.classList.add("hidden");
    this.handleSave();
  }
}
customElements.define("product-gift-note-form", ProductGiftNoteForm);
